import type { ChatReaction } from "~shared/chatExperienceSurvey";

export function ChatReactionIcon({ reaction }: { reaction: ChatReaction }) {
  return (
    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
      {reaction === "fine" ? <>
        <circle cx="12" cy="12" r="9" />
        <path d="M8 15h8M8 9h.01M16 9h.01" />
      </> : <g transform={reaction === "dislike" ? "rotate(180 12 12)" : undefined}>
        <path d="M7 10l4-7c2 0 3 1 2 4l-1 3h7a2 2 0 0 1 2 2l-2 7a2 2 0 0 1-2 2H7zM3 10h4v11H3z" />
      </g>}
    </svg>
  );
}
